//core here
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { ModalModule } from 'ngx-bootstrap';
import { FlashMessagesModule } from 'angular2-flash-messages';
import { CustomFormsModule } from 'ng2-validation';

//routing here
import { AppAdminRoutingModule } from './app-admin.routes';

import { reducer } from './common/reducers';
import { AuthEffects } from './common/effects/user';
//component here
import { AppAdminComponent } from './app-admin.component';

//module here
import { LayoutModule } from './layout/layout.module';
import { AuthenticateModule } from './pages/admin/auth/authenticate.module';

import { IContactModule } from './pages/admin/icontact/iContactModule';
// //service here
import { AuthGuard } from './common/services/Auth.guard';
import { ApiEvsService } from './common/services/ApiEvs.service';
import { AuthenticateService } from './common/services/Authenticate.service';
import { ConfirmPhoneGuard } from './confirm-phone.guard';
import { PagerService } from './common/services/Pagination.service';
import { environment } from '../environments/environment';
import {ToastrModule} from 'ngx-toastr';
import { SocketService } from './common/services/Socket.service';
import { TicketService } from './common/services/Ticket.service';
import { ChatService } from './common/services/Chat.service';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PushNotificationsService } from './common/services/Notifycation.service';
import {ExportService} from './common/services/Export.service';

@NgModule({
    declarations: [
        AppAdminComponent
    ],
    imports: [
        BrowserModule,
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        HttpModule,
        StoreModule.provideStore(reducer),
        FlashMessagesModule,
        CustomFormsModule,

        EffectsModule.run(AuthEffects),

        // Admin Module
        AppAdminRoutingModule,
        AuthenticateModule,
        LayoutModule,
        ToastrModule.forRoot(),

        ModalModule.forRoot(),

        IContactModule,
        TooltipModule.forRoot()
    ],
    providers: [
        AuthGuard,
        AuthenticateService,
        ApiEvsService,
        ConfirmPhoneGuard,
        PagerService,
        SocketService,
        TicketService,
        ChatService,
        PushNotificationsService,
        ExportService,
    ],
    bootstrap: [AppAdminComponent]
})
export class AppAdminModule {
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/app-admin.module.ts